"use client";

import { Header } from "@/components/shared/public";
import TitleH2 from "@/components/shared/public/fonts/TitleH2";
import ScrollReveal from "@/components/shared/public/ScrollReveal";
import { Vacancy } from "@/components/shared/public/vacancy";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { team } from "../../../../../public/images/backgrounds";

export default function VacanciesContent() {
  const t = useTranslations("vacancies");

  return (
    <div className="[--h1-weight:500] [--heading-scale:0.6]">
      <Header
        title={t("head.title")}
        subtitle={t("head.title2")}
        containerClass="gs--page-column gs--page-column--wide"
      />
      <section className="gs--page-column gs--page-column--wide py-16">
        <TitleH2
          title={t("sections.section1.title")}
          className="text-primary pb-5 text-center"
        />
        <div className="flex flex-col-reverse items-center md:flex-row-reverse md:gap-12">
          <div className="text-ring">
            <p>{t("sections.section1.text")}</p>
            <ol className="mt-4 ml-4 list-decimal">
              <li>{t("sections.section1.li1")}</li>
              <li>{t("sections.section1.li2")}</li>
              <li>{t("sections.section1.li3")}</li>
              <li>{t("sections.section1.li4")}</li>
              <li>{t("sections.section1.li5")}</li>
              <li>{t("sections.section1.li6")}</li>
            </ol>
          </div>
          <Image
            className="mb-3"
            src={team}
            alt={t("sections.section1.imageAlt")}
            width={950 * 0.4}
            height={686 * 0.4}
          />
        </div>

        <ScrollReveal>
          <TitleH2
            title={t("sections.section2.title")}
            className="text-primary mt-20 pb-5 text-center"
          />
          <p className="text-ring mb-20">{t("sections.section2.text")}</p>
        </ScrollReveal>

        <ScrollReveal>
          <Vacancy
            title={t("vacancies.vacancy1.title")}
            location={t("vacancies.vacancy1.place")}
            time={t("vacancies.vacancy1.time")}
            task1={t("vacancies.vacancy1.task1")}
            task2={t("vacancies.vacancy1.task2")}
            task3={t("vacancies.vacancy1.task3")}
            task4={t("vacancies.vacancy1.task4")}
            task5={t("vacancies.vacancy1.task5")}
            profile1={t("vacancies.vacancy1.profile1")}
            profile2={t("vacancies.vacancy1.profile2")}
            profile3={t("vacancies.vacancy1.profile3")}
            profile4={t("vacancies.vacancy1.profile4")}
            profile5={t("vacancies.vacancy1.profile5")}
            profile6={t("vacancies.vacancy1.profile6")}
          />
        </ScrollReveal>

        <ScrollReveal>
          <Vacancy
            title={t("vacancies.vacancy2.title")}
            location={t("vacancies.vacancy2.place")}
            time={t("vacancies.vacancy2.time")}
            task1={t("vacancies.vacancy2.task1")}
            task2={t("vacancies.vacancy2.task2")}
            task3={t("vacancies.vacancy2.task3")}
            profile1={t("vacancies.vacancy2.profile1")}
            profile2={t("vacancies.vacancy2.profile2")}
            profile3={t("vacancies.vacancy2.profile3")}
            profile4={t("vacancies.vacancy2.profile4")}
          />
        </ScrollReveal>

        <ScrollReveal>
          <Vacancy
            title={t("vacancies.vacancy3.title")}
            location={t("vacancies.vacancy3.place")}
            time={t("vacancies.vacancy3.time")}
            task1={t("vacancies.vacancy3.task1")}
            task2={t("vacancies.vacancy3.task2")}
            profile1={t("vacancies.vacancy3.profile1")}
            profile2={t("vacancies.vacancy3.profile2")}
            profile3={t("vacancies.vacancy3.profile3")}
            profile4={t("vacancies.vacancy3.profile4")}
            profile5={t("vacancies.vacancy3.profile5")}
            profile6={t("vacancies.vacancy3.profile6")}
          />
        </ScrollReveal>

        <ScrollReveal>
          <Vacancy
            title={t("vacancies.vacancy4.title")}
            location={t("vacancies.vacancy4.place")}
            time={t("vacancies.vacancy4.time")}
            task1={t("vacancies.vacancy4.task1")}
            task2={t("vacancies.vacancy4.task2")}
            profile1={t("vacancies.vacancy4.profile1")}
            profile2={t("vacancies.vacancy4.profile2")}
            profile3={t("vacancies.vacancy4.profile3")}
            profile4={t("vacancies.vacancy4.profile4")}
            profile5={t("vacancies.vacancy4.profile5")}
          />
        </ScrollReveal>

        <ScrollReveal>
          <Vacancy
            title={t("vacancies.vacancy5.title")}
            location={t("vacancies.vacancy5.place")}
            time={t("vacancies.vacancy5.time")}
            task1={t("vacancies.vacancy5.task1")}
            task2={t("vacancies.vacancy5.task2")}
            task3={t("vacancies.vacancy5.task3")}
            task4={t("vacancies.vacancy5.task4")}
            profile1={t("vacancies.vacancy5.profile1")}
            profile2={t("vacancies.vacancy5.profile2")}
            profile3={t("vacancies.vacancy5.profile3")}
            profile4={t("vacancies.vacancy5.profile4")}
            profile5={t("vacancies.vacancy5.profile5")}
            profile6={t("vacancies.vacancy5.profile6")}
          />
        </ScrollReveal>

        <ScrollReveal>
          <Vacancy
            title={t("vacancies.vacancy6.title")}
            location={t("vacancies.vacancy6.place")}
            time={t("vacancies.vacancy6.time")}
            task1={t("vacancies.vacancy6.task1")}
            profile1={t("vacancies.vacancy6.profile1")}
            profile2={t("vacancies.vacancy6.profile2")}
            profile3={t("vacancies.vacancy6.profile3")}
            profile4={t("vacancies.vacancy6.profile4")}
            profile5={t("vacancies.vacancy6.profile5")}
            profile6={t("vacancies.vacancy6.profile6")}
          />
        </ScrollReveal>
      </section>
    </div>
  );
}
